import { useStore } from 'react-redux';
import { useEffect } from 'react';
import { usersActions, RootState, useDispatch } from '../api';
import isClientside from '../utils/isClientside';

export const useUserStatus = (userIds: number | number[]) => {
  const dispatch = useDispatch();

  const state = useStore<RootState>();
  const { isLoggedIn } = state.getState().authentication;

  // This effect should only be run client side, because otherwise the server
  // subscribes to all pusher channels.
  useEffect(() => {
    if (isClientside && isLoggedIn) {
      dispatch(usersActions.subscribeToOnlineStatus(userIds));
    }

    return () => {
      if (isClientside && isLoggedIn) {
        dispatch(usersActions.unsubscribeFromOnlineStatus(userIds));
      }
    };
  });
};
